import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetFavoriteReports'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetFavoriteReportsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetFavoriteReportsStore",
			variables: false,
		})
	}
}

export async function load_GetFavoriteReports(params) {
  await initClient()

	const store = new GetFavoriteReportsStore()

	await store.fetch(params)

	return {
		GetFavoriteReports: store,
	}
}
